/* Lo del ingreso con QR y llave de acceso que se decide en el navegador, sin
 * red: si es una compu, si este navegador ya tiene una llave, y el corte de
 * sesiones de una sola vez (Igna, 02/11).
 *
 * Todo lo de `localStorage` va con try/catch: en una ventana privada o con el
 * almacenamiento bloqueado tira, y el ingreso tiene que seguir andando. */

/* El corte de una sola vez (Igna, 02/11): toda sesión de COMPU que se abrió
 * antes de este momento se cierra, para que vean la pantalla nueva con el QR.
 * Moverlo para adelante vuelve a sacar a todas las compus. */
export const CORTE_LOGIN = Date.parse("2026-11-03T00:00:00-03:00");
const MARCA_LLAVE = "hub-tiene-llave";
export const RECIEN_ENTRO = "hub-recien-entro";

function leer(k, donde = localStorage) {
  try {
    return donde.getItem(k);
  } catch {
    return null;
  }
}

function poner(k, v, donde = localStorage) {
  try {
    donde.setItem(k, v);
  } catch {
    /* sin almacenamiento: se sigue igual */
  }
}

function sacar(k, donde = localStorage) {
  try {
    donde.removeItem(k);
  } catch {
    /* idem */
  }
}

/* Compu o celular. Un iPad con Safari se presenta como Mac: se lo reconoce
 * por la pantalla táctil. Ante la duda, compu — es lo que muestra el QR, y la
 * contraseña está siempre a mano. */
export function esCelular(nav = typeof navigator !== "undefined" ? navigator : {}) {
  const ua = nav.userAgent || "";
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
  return /Macintosh/.test(ua) && (nav.maxTouchPoints || 0) > 1;
}

export const esCompu = (nav) => !esCelular(nav);

// El navegador sabe hacer llaves de acceso.
export function llavesDisponibles() {
  return typeof window !== "undefined" && !!window.PublicKeyCredential;
}

// Si en ESTE navegador ya se creó (o se usó) una llave: es lo que hace
// aparecer el botón «Entrar con llave de acceso».
export const tieneLlave = () => leer(MARCA_LLAVE) === "1";
export const marcarLlave = () => poner(MARCA_LLAVE, "1");
export const olvidarLlave = () => sacar(MARCA_LLAVE);

/* Cuándo se abrió esta sesión: el token de acceso trae en `amr` el momento
 * en que la persona se autenticó (y no cambia al renovarse el token). `null`
 * si no se puede leer — y entonces no se corta nada. */
export function inicioDeSesion(accessToken) {
  try {
    const cuerpo = accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const amr = JSON.parse(atob(cuerpo)).amr || [];
    const ts = Math.max(...amr.map((a) => Number(a.timestamp) || 0));
    return ts > 0 ? ts * 1000 : null;
  } catch {
    return null;
  }
}

// Si esta sesión es de una compu y es de antes del corte. El celular no.
export function tocaCorte(session, nav) {
  if (!session || !esCompu(nav)) return false;
  const inicio = inicioDeSesion(session.access_token);
  return inicio !== null && inicio < CORTE_LOGIN;
}

// Quien entra desde la pantalla de ingreso a una compu, en esta pestaña: el
// aviso de «generá una llave» se muestra una vez por ingreso.
export const marcarRecienEntro = () => poner(RECIEN_ENTRO, "1", sessionStorage);
export function tomarRecienEntro() {
  const si = leer(RECIEN_ENTRO, sessionStorage) === "1";
  if (si) sacar(RECIEN_ENTRO, sessionStorage);
  return si;
}

/* La pantalla donde el celular aprueba el QR se abre en una pestaña nueva (la
 * cámara abre el link), y una pestaña nueva cierra la sesión del hub
 * (`isLogged` es por pestaña). Ésa sola se deja pasar: si no, el celular
 * nunca podría aprobar. */
export const esAprobacionQr = (ruta) => /^\/qr\/[^/]+$/.test(ruta || "");
